import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 32,
		height: 32,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function CloudServiceActiveIcon(props) {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M19.3793 25H10.6897H6.34483C3.94525 25 2 23.0548 2 20.6552C2 18.3682 3.76694 16.4939 6.01013 16.3231C6.24191 11.134 10.42 7 15.5402 7C19.6572 7 23.1651 9.67273 24.5022 13.4176C24.5694 13.4151 24.6368 13.4138 24.7046 13.4138C27.6292 13.4138 30 15.7846 30 18.7092V19.2069C30 22.4063 27.4063 25 24.2069 25H19.3793Z" fill="white" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<CloudServiceActiveIcon fill={props.fill} />
		</div>
	);
}